/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Draftemail_Access_Neverremoves3Inputs */

const en_coinvestments_draftemail_access_neverremoves3 = /** @type {(inputs: Coinvestments_Draftemail_Access_Neverremoves3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sending never removes access`)
};

/**
* | output |
* | --- |
* | "Sending never removes access" |
*
* @param {Coinvestments_Draftemail_Access_Neverremoves3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_draftemail_access_neverremoves3 = /** @type {((inputs?: Coinvestments_Draftemail_Access_Neverremoves3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Draftemail_Access_Neverremoves3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_draftemail_access_neverremoves3(inputs)
});
export { coinvestments_draftemail_access_neverremoves3 as "coInvestments_draftEmail_access_neverRemoves" }